export const getVatRates = (state) => Object.values(state.vatRates.byID);
export const getVatRateByID = (id) => (state) => state.vatRates.byID[id] || {};
